
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.082 10.266a.907.907 0 000 1.285l5.276 4.182a.906.906 0 001.285 0l5.276-4.182a.908.908 0 10-1.285-1.285l-4.638 3.536-4.63-3.536a.916.916 0 00-1.284 0z"}})])
          )
        }
      }
    